const ProductDetails = [
    {
        id: 1,
        category: 'Laptops',
        brand: {
            brandName: 'Asus',
            subBrand: 'ROG'
        },
        featured: 'no',
        newArrival: 'yes',
        title: 'Asus ROG Strix Scar 15 (2022)',
        image: 'ProductImages/Asus_Laptop.png',
        price: 273300,
        rating: 4,
        productDescription: '15.6 Inches 2K Wqhd 240Hz/3Ms Intel Core I9-12900H 12Th Gen RTX 3070 Ti 8Gb Graphics Gaming Laptop (32Gb/2Tb Ssd/Windows 11 Home/Office 2021/Black/2.3 Kg) G533Zw-Ln106Ws'
    },
    {
        id: 2,
        category: 'Laptops',
        brand: {
            brandName: 'Apple',
            subBrand: 'MacBook'
        },
        featured: 'yes',
        newArrival: 'no',
        title: 'MacBook Pro (2022)',
        image: 'ProductImages/MacBook_Pro.png',
        price: 309990,
        rating: 4,
        productDescription: '16-inch/41.05 cm, Apple M1 Max chip with 10‑core CPU and 32‑core GPU, 32GB RAM, 1TB SSD'
    },
    {
        id: 3,
        category: 'Shoes',
        brand: {
            brandName: 'ASIAN',
            subBrand: 'Running Shoes'
        },
        featured: 'no',
        newArrival: 'no',
        title: 'ASIAN Blade-13 Running Shoes for Men',
        image: 'ProductImages/Shoes.png',
        price: 616,
        rating: 3,
        productDescription: 'Port Shoes for Boys with EVA Sole Technology, Casual Sneaker Running Shoes for Mens & Boys'
    },
    {
        id: 4,
        category: 'Smart Phones',
        brand: {
            brandName: 'Samsung',
            subBrand: 'Galaxy'
        },
        featured: 'yes',
        newArrival: 'yes',
        title: 'Samsung Galaxy S22 Ultra 5G',
        image: 'ProductImages/Samsung_Galaxy_S22_Ultra.png',
        price: 109999,
        rating: 5,
        productDescription: 'Phantom Black, 12GB, 512GB Storage'
    },
    {
        id: 5,
        category: 'Smart Phones',
        brand: {
            brandName: 'Apple',
            subBrand: 'iPhone'
        },
        featured: 'yes',
        newArrival: 'no',
        title: 'Apple iPhone 13 Pro Max',
        image: 'ProductImages/iPhone_13_Pro_Max.png',
        price: 125900,
        rating: 5,
        productDescription: '(256GB) - Sierra Blue'
    },
    {
        id: 6,
        category: 'Home Appliances',
        brand: {
            brandName: 'Samsung',
            subBrand: 'TV'
        },
        featured: 'no',
        newArrival: 'no',
        title: 'Samsung QLED TV (2022)',
        image: 'ProductImages/Samsung_TV.png',
        price: 224990,
        rating: 4,
        productDescription: '163 cm (65 inches) 8K Ultra HD Smart Neo QLED TV QA65QN85BAKLXL (Bright Silver)'
    },
    {
        id: 7,
        category: 'Home Appliances',
        brand: {
            brandName: 'Samsung',
            subBrand: 'Refrigerator'
        },
        featured: 'no',
        newArrival: 'no',
        title: 'Samsung Side-by-Side Refrigerator',
        image: 'ProductImages/Fridge.png',
        price: 182100,
        rating: 4,
        productDescription: '(RS74T5F01B4/TL, Matt Black)'
    },
    {
        id: 8,
        category: 'Smart Phones',
        brand: {
            brandName: 'OnePlus',
            subBrand: 'Phones'
        },
        featured: 'no',
        newArrival: 'yes',
        title: 'OnePlus 10 Pro 5G',
        image: 'ProductImages/OnePlus_10_Pro.png',
        price: 66999,
        rating: 4,
        productDescription: '(Volcanic Black, 12GB RAM, 256GB Storage)'
    },
    {
        id: 9,
        category: 'Apparels',
        brand: {
            brandName: 'London',
            subBrand: 'Hills'
        },
        featured: 'no',
        newArrival: 'no',
        title: 'London Hills T-Shirt',
        image: 'ProductImages/T-Shirt.png',
        price: 179,
        rating: 3,
        productDescription: 'Solid Mens Round Neck Sports T-Shirt'
    },
    {
        id: 10,
        category: 'Apparels',
        brand: {
            brandName: 'Levis',
            subBrand: 'Jeans'
        },
        featured: 'no',
        newArrival: 'no',
        title: 'Levis Slim Fit Jeans',
        image: 'ProductImages/Jeans.png',
        price: 1304,
        rating: 5,
        productDescription: 'Mens 511 Slim Fit Jeans'
    },
    {
        id: 11,
        category: 'Home Appliances',
        brand: {
            brandName: 'LG',
            subBrand: 'Convection Oven'
        },
        featured: 'no',
        newArrival: 'no',
        title: 'LG Convection Microwave Oven',
        image: 'ProductImages/Microwave-oven.png',
        price: 22750,
        rating: 4,
        productDescription: '32 Litres Convection Microwave Oven (Charcoal Lightning Heater, MJEN326UH, Black)'
    },
    {
        id: 12,
        category: 'Smart Phones',
        brand: {
            brandName: 'Samsung',
            subBrand: 'Galaxy'
        },
        featured: 'no',
        newArrival: 'yes',
        title: 'Samsung Galaxy S22 5G',
        image: 'ProductImages/Samsung_Galaxy_S22.png',
        price: 52999,
        rating: 4,
        productDescription: 'Green, 8GB, 128GB Storage'
    }
]

export default ProductDetails